import { PropsWithChildren, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { NotFoundPage } from '@/components/common/NotFoundPage';
import { Loader } from '@/components/layout/Loader/Loader';
import { AuthContext } from '@/contexts/AuthContext';
import { getUserDefaultRoute } from '@/modules/core/auth/utils/getUserDefaultRoute';

export function GuestRoute({ children }: PropsWithChildren) {
  const router = useRouter();
  const { user, isAuthLoading } = useContext(AuthContext);
  const redirectDestination = getUserDefaultRoute(user);

  useEffect(() => {
    if (!isAuthLoading && user && redirectDestination) {
      router.replace(redirectDestination);
    }
  }, [isAuthLoading, redirectDestination, router, user]);

  if (isAuthLoading || redirectDestination) {
    return <Loader />;
  }

  if (user) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
}
